import type { Fund } from "@/data/funds";
import { fundLiveAumDollars } from "@/hooks/use-fund-live-data";

/**
 * The homepage grid's default view: the top `count` funds by live AUM
 * (descending), ties and missing AUM broken by ticker (ascending) so the
 * selection is fully deterministic for a given fund list.
 *
 * PURE on purpose — the static prerender bakes the homepage from the same
 * seeded fund list the browser hydrates with, so both sides MUST derive the
 * identical 8 cards from this one function (user-directed top-8 default,
 * 2026-07-02).
 */
export function topFundsByAum(funds: readonly Fund[], count: number): Fund[] {
  return [...funds]
    .sort((a, b) => {
      const byAum = (fundLiveAumDollars(b) ?? 0) - (fundLiveAumDollars(a) ?? 0);
      if (byAum !== 0) return byAum;
      return a.ticker.localeCompare(b.ticker);
    })
    .slice(0, count);
}
